import React from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

export const ParticipantsIcon = (props: SvgIconProps) => (
  <SvgIcon
    width="28"
    height="28"
    viewBox="0 0 28 28"
    {...props}
    sx={{ fill: 'none' }}
  >
    <path
      opacity="0.2"
      d="M9.625 17.5C12.7661 17.5 15.3125 14.9536 15.3125 11.8125C15.3125 8.67138 12.7661 6.125 9.625 6.125C6.48388 6.125 3.9375 8.67138 3.9375 11.8125C3.9375 14.9536 6.48388 17.5 9.625 17.5Z"
      fill="white"
    />
    <path
      d="M9.625 17.5C12.7661 17.5 15.3125 14.9536 15.3125 11.8125C15.3125 8.67138 12.7661 6.125 9.625 6.125C6.48388 6.125 3.9375 8.67138 3.9375 11.8125C3.9375 14.9536 6.48388 17.5 9.625 17.5Z"
      stroke="white"
      strokeWidth="2"
      strokeMiterlimit="10"
    />
    <path
      d="M16.9961 6.33281C17.4989 6.19645 18.0173 6.12659 18.5383 6.125C20.0467 6.125 21.4933 6.72422 22.56 7.79083C23.6266 8.85744 24.2258 10.3041 24.2258 11.8125C24.2258 13.3209 23.6266 14.7676 22.56 15.8342C21.4933 16.9008 20.0467 17.5 18.5383 17.5"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.75 21.5905C2.63807 20.3268 3.81723 19.2953 5.18788 18.5833C6.55854 17.8712 8.08043 17.4995 9.625 17.4995C11.1696 17.4995 12.6915 17.8712 14.0621 18.5833C15.4328 19.2953 16.6119 20.3268 17.5 21.5905"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.5391 17.5C20.0838 17.499 21.606 17.8703 22.9768 18.5824C24.3476 19.2944 25.5266 20.3263 26.4141 21.5906"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);
